import {LabelWithoutJson} from '@/components/atoms'
import {FONT_WEIGHT} from '@/utils/constants/globalStyle'
import './_readOnly.scss'

/**
 * ReadOnly component displays a label and a value in a read-only format.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.id - The unique identifier for the component.
 * @param {string} props.label - The label text to display.
 * @param {string} props.value - The value text to display.
 * @param {boolean} [props.isBottomBorderVisible=true] - Flag to determine if the bottom border should be visible.
 * @param {boolean} [props.isValueDiasbledInput=false] - Flag to determine if the value should be displayed as a disabled input.
 *
 * @returns {JSX.Element} The rendered ReadOnly component.
 */
const ReadOnly = ({id, label, value, isBottomBorderVisible = true, isValueDiasbledInput = false}) => {
  return (
    <div className={` flex h-[38px] w-full pb-2 pt-2 ${isBottomBorderVisible && 'ro-borderBottom'}`}>
      <div className="w-49">
        <LabelWithoutJson id={`${id}_label`} text={label} />
      </div>
      <div className="w-49">
        <LabelWithoutJson
          id={`${id}_value`}
          text={value}
          isValueDiasbledInput={isValueDiasbledInput}
          fontWeight={FONT_WEIGHT.BOLD}
        />
      </div>
    </div>
  )
}
export default ReadOnly
